import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../Header/Header";
import foodbrand from "../../assets/foodbrand@2x.png";

const NumeroLic = () => {

  const navigate = useNavigate();
  const [value, setValue] = useState("");
  const [showContinue, setShowContinue] = useState(false);

  const handleChange = (event) => {
    const newValue = event.target.value.slice(0, 16).toUpperCase();
    if (event.target.value.length >= 6) {
      setShowContinue(true);
    }
    else {
      setShowContinue(false);
    }
    localStorage.setItem('numeroLicencia', newValue);
    setValue(newValue);
  };

  const getContinueDate = async () => {
    navigate("/LicDate");
  };

  const style = {
    height: "52px",
    borderColor: "#c4cbd1 !important",
    display: "block",
    width: "100%",
    padding: "13px 0 13px 15px",
    border: "1px solid #c4cbd1",
    borderRadius: "0.375rem",
  };

  return (
    <>
      <div className="initBack_P2 animate__animated animate__fadeIn">
        <Header
          imgBack={true}
          rutaBack="/TipoLicencia"
          title="Licencia de Conducir"
          name="NumeroLic"
        />

        <div className="containerRender">
          <div className="containerInfo_P2">
            <div className="containerIdent_P2">
              <p className="txtNat_Licencia">Número</p>

              <input
                style={style}
                type="text"
                value={value}
                onChange={handleChange}
                placeholder="Escriba su número de licencia"
              />
              <hr className="line" />

              {showContinue ? (
                <>
                  <button
                    className="button_P2 animate__animated animate__fadeIn"
                    onClick={getContinueDate}
                  >
                    <span className="txtButton_P2">Continuar</span>
                  </button>
                </>
              ) : (
                <>
                  <button className='btnVer_P3' >
                    <span className='txtVer_P3'>Continuar</span>
                  </button>
                </>
              )}

            </div>
          </div>
        </div>
        <div className="footer">
          <div className="imageContainer_P2">
            <img src={foodbrand} className="imgFooter_P2" />
          </div>
        </div>
      </div>
    </>
  );
};

export default NumeroLic;
